import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React from 'react';
import CustomButton from '../../../../../../../lib/designSystem/Button';

const DeleteDialog = (props: any) => {
  const {
    confirmDeleteOpen,
    setConfirmDeleteOpen,
    handleConfirmDelete,
    toDeleteFolder,
    setToDeleteFolder,
    fileToDelete,
  } = props;
  return (
    <Dialog
      open={confirmDeleteOpen}
      onClose={() => {
        setConfirmDeleteOpen(false);
        setToDeleteFolder(false);
      }}
    >
      <DialogTitle>
        Eliminar {toDeleteFolder ? 'carpeta' : 'documento'}
      </DialogTitle>
      <DialogContent>
        <Typography>
          ¿Estás seguro de querer eliminar{' '}
          {toDeleteFolder ? (
            <>
              la carpeta "<Typography component="span" fontWeight="bold">{fileToDelete?.name.slice(0, -1)}</Typography>"? Las carpetas solo serán eliminadas si estan vacías.
            </>
          ) : (
            <>
              el documento "<Typography component="span" fontWeight="bold">{fileToDelete?.name}</Typography>"?
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <CustomButton
          onClick={() => {
            setConfirmDeleteOpen(false);
            setToDeleteFolder(false);
          }}
          color="secondary"
        >
          Cancelar
        </CustomButton>
        <CustomButton onClick={handleConfirmDelete} color="error">
          Eliminar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;
